import { APP_CONFIG } from "@/domains/global/config";
import { TrackedEvent, trackEvent } from "@/domains/metrics";
import { clientEnvModule } from "@/modules/client-env";
import { openWindowUrlInNewTab } from "@/modules/window/navigation";
import { MDSIcon, MDSIconKind, MDSTextVariant, MDSTextWeight, MDSText } from "@/mds";
import {
  AppDownloadButton,
  AppIconWrapper,
} from "@/components/onboarding/components/app-download-button";

type platform = "mac" | "windows";
const Config: Record<
  platform,
  { to: string; option: string; url: string; iconKind: MDSIconKind; appName: string }
> = {
  mac: {
    to: "download-mac-app",
    option: "mac-app",
    url: APP_CONFIG.URLS.MAC_APP,
    iconKind: MDSIconKind.BrandApple,
    appName: "Mac app",
  },
  windows: {
    to: "download-windows-app",
    option: "windows-app",
    url: APP_CONFIG.URLS.WINDOWS_APP,
    iconKind: MDSIconKind.BrandWindows,
    appName: "Windows app",
  },
};

export const DownloadDesktopAppStep: React.FC = () => {
  const isMacBrowser = clientEnvModule.isMacBrowser();
  const isWindowsBrowser = clientEnvModule.isWindowsBrowser();
  const isWinOrMacBrowser = isMacBrowser || isWindowsBrowser;
  const platform = isMacBrowser ? "mac" : "windows"; // if we add a 3rd platform we might need a switch statement
  const config = Config[platform];

  const handleDownloadDesktopApp = async () => {
    trackEvent(TrackedEvent.ImportWizardStepChange, {
      from: "download-apps",
      to: config.to,
      source: "welcome_wizard",
    });
    trackEvent(TrackedEvent.OnboardingDownloadClick, {
      option: config.option,
    });

    await openWindowUrlInNewTab({ url: new URL(config.url) });
  };

  if (!isWinOrMacBrowser) {
    return null;
  }

  return (
    <AppDownloadButton onClick={handleDownloadDesktopApp}>
      <AppIconWrapper data-icon-wrapper isApple={isMacBrowser}>
        <MDSIcon kind={config.iconKind} size={16} />
      </AppIconWrapper>
      <MDSText variant={MDSTextVariant.ParagraphSm} weight={MDSTextWeight.Regular}>
        Download {config.appName}
      </MDSText>
    </AppDownloadButton>
  );
};
